<template>
  <div class="referee-container">
    <el-tabs v-model="activeName" type="card" >
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="player" class="user-from" label-width="140px" >
          <el-form-item class="label-line-height" label="上传头像" >
            <el-upload
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.profile | ImageFormats" alt="img"/></div>
                <img slot="reference" v-show="player.profile" :src="player.profile | ImageFormats" >
              </el-popover>
              <i v-show="!player.profile" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="player.trueName" />
          </el-form-item>
          <el-form-item label="性别" >
            <el-radio v-model="player.gender" label="男">男</el-radio>
            <el-radio v-model="player.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="国籍">
            <el-select v-model="player.nationality" filterable placeholder="请选择国籍">
              <el-option label="中国" value="中国"/>
              <el-option label="其他" value="其他"/>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" >
            <el-date-picker
              v-model="player.birthday"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-select v-model="player.certificateType" filterable placeholder="身份证">
              <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input v-model="player.certificateNum" />
          </el-form-item>
          <el-form-item label="证件正面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateFront"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateFrontImg | ImageCertFormats" alt="img"/></div>
                <img slot="reference" v-show="player.certificateFrontImg" :src="player.certificateFrontImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateFrontImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件反面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateBack"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateBackImg | ImageCertFormats" alt="img"/></div>
                <img slot="reference" v-show="player.certificateBackImg" :src="player.certificateBackImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateBackImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身高(CM)">
            <el-input v-model="player.high" />
          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-input v-model="player.weight" />
          </el-form-item>
          <el-form-item label="文化程度" >
            <el-select v-model="player.educationLevel" filterable placeholder="请选择">
              <el-option label="小学" value="小学"/>
              <el-option label="初中" value="初中"/>
              <el-option label="高中" value="高中"/>
              <el-option label="专科" value="专科"/>
              <el-option label="本科" value="本科"/>
              <el-option label="硕士" value="硕士"/>
              <el-option label="博士" value="博士"/>
            </el-select>
          </el-form-item>
          <el-form-item label="文化语种及程度">
            <el-select v-model="language.foreign" filterable placeholder="请选择语言">
              <el-option label="汉语" value="汉语"/>
              <el-option label="法语" value="法语"/>
              <el-option label="德语" value="德语"/>
              <el-option label="英语" value="英语"/>
              <el-option label="俄语" value="俄语"/>
              <el-option label="西班牙语" value="西班牙语"/>
              <el-option label="葡萄牙语" value="葡萄牙语"/>
              <el-option label="瑞典语" value="瑞典语"/>
            </el-select>
            <el-select v-model="language.level" filterable placeholder="请选择水平">
              <el-option label="一般" value="一般"/>
              <el-option label="良好" value="良好"/>
              <el-option label="熟练" value="熟练"/>
              <el-option label="精通" value="精通"/>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="指导员级别">-->
            <!--<el-select v-model="player.instructorLevel" filterable placeholder="请选择级别">-->
              <!--<el-option label="一级" value="一级"/>-->
              <!--<el-option label="二级" value="二级"/>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="裁判等级">-->
            <!--<el-select v-model="player.refereeLevel" filterable placeholder="请选择级别">-->
              <!--<el-option label="一级" value="一级"/>-->
              <!--<el-option label="二级" value="二级"/>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
          <el-form-item label="指导员级别">
            <el-input v-model="player.instructorLevel" />
          </el-form-item>
          <el-form-item label="裁判等级">
            <el-input v-model="player.refereeLevel" />
          </el-form-item>
          <el-form-item label="裁判证号">
            <el-input v-model="player.refereeCertificateNo" />
          </el-form-item>
          <el-form-item label="批准日期" >
            <el-date-picker
              v-model="player.refereeCertificateDate"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="工作单位">
            <el-input v-model="player.employerOrganization" />
          </el-form-item>
          <el-form-item label="工作地址">
            <el-input v-model="player.workplaceAddress" />
          </el-form-item>
          <el-form-item label="再次注册年度" >
            <el-input v-model="player.membershipYear" disabled />
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史注册年度<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyYears" :key="item.year">{{ item.year }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="请选择渠道">
            <el-select v-model="player.source" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请填写其他渠道" v-if="player.source==sourceList[3]">
            <el-input
              :rows="2"
              v-model="player.otherSource"
              type="textarea"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-outReferee-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="个人经历" name="second">
        <el-form v-if="player" label-width="96px" class="lce-hockey-level" >
          <el-form-item label="运动员经历">
            <el-input
              v-model="player.athletePerformance"
              type="textarea"
              rows="3"
              placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="裁判员主要经历">
            <el-input
              v-model="player.refereePerformance"
              type="textarea"
              rows="3"
              placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="训练经历">
            <el-button @click="addTrainingRecord()" >添加</el-button>
          </el-form-item>
          <el-form-item label="">
            <el-row
              v-for="(item, i) in trainingList"
              :key="i">
              <el-col :span="12">
                <el-col :span="4">培训名称</el-col>
                <el-col :span="4"><el-input v-model="item.seq"></el-input></el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="4">时长(小时)</el-col>
                <el-col :span="4"><el-input v-model="item.time" type="number"></el-input></el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="2">成绩</el-col>
                <el-col :span="3"><el-input v-model="item.score"></el-input></el-col>
              </el-col>
              <el-col :span="9">
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="3">开始时间</el-col>
                <el-col :span="7"><el-input v-model="item.begin"></el-input></el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="3">结束时间</el-col>
                <el-col :span="7"><el-input v-model="item.end"></el-input></el-col>
              </el-col>
              <el-col :span="1"><el-button type="danger" @click="removeTrainingRecord(i)" >删除</el-button></el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-outReferee-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="联系方式" name="third">
        <el-form v-if="player" label-width="96px" class="hockey-contact" >
          <el-form-item label="固定电话" >
            <el-input v-model="player.contactnumber" />
          </el-form-item>
          <el-form-item label="联系电话" >
            <el-input v-model="player.mobile" />
          </el-form-item>
          <el-form-item label="邮箱" >
            <el-input v-model="player.email" />
          </el-form-item>
          <el-form-item label="住址" >
            <el-input v-model="player.workplaceAddress" />
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-outReferee-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import moment from 'moment'
  import permission from '@/directive/permission/index.js' // 权限判断指令
  import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
  import { getQiniuUploadToken, getSourceList } from '@/api/site'
  import { getOrganizationList, getCoachList, getHistoryMembershipYear } from '@/api/user'
  import { getRefereeInfo, updateReferee } from '@/api/referee'

  const certificateType = ConstConfig.certificateType

  export default {
    name: 'Details',
    directives: { permission },
    data() {
      return {
        activeName: 'first',
        organizationId: null,
        dataObj: { token: '' },
        qiniuUp: varConfig.qiniuUp,
        accept: ConstConfig.accept,
        profile: '',
        playerId: '',
        player: null,
        certificateType: certificateType,
        userLoding: false,
        coach: '',
        historyYears: [],
        language: {},
        sourceList: [],
        trainingList:[]
      }
    },
    created() {
      this.playerId = this.$route.params.id
      this.getPlayerInfo()
      this.getQiniuToken()
//      this.getSchool()
      this.getOrganization()
//      this.getCoach()
      this.sourceList = getSourceList()
    },
    mounted() {},
    methods: {
      addTrainingRecord(){
        this.trainingList.push({})
      },
      removeTrainingRecord(i){
        this.trainingList.splice(i, 1)
      },
      getTrainingList(origin){
        const l = 3 - origin.length
        for(let i = 0; i < l; i++) {
          origin.push({})
        }
        this.trainingList = this.trainingList.concat(origin)
      },
      getPlayerInfo() {
        const params = { id: this.playerId, inField: 0 }
        getRefereeInfo(params).then((resolve) => {
          const player = resolve.data
          if (player.source) {
            if (!this.sourceList.includes(player.source)) {
              player.otherSource = player.source
              player.source = this.sourceList[3]
            }
          }
          this.player = player
          if (this.player.foreignLanguage && this.player.foreignLanguage.indexOf('|')>-1) {
              const arr = this.player.foreignLanguage.split('|')
              this.language = {
                foreign: arr[0],
                level: arr[1]
              }
          }
          this.getHistoryMembershipYear(this.player.userId)
          this.getTrainingList(player.trainings)
        }, (reject) => {
          console.log(reject)
        })
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          showMessage('error', '上传头像图片大小不能超过 10MB!')
        }
        return isLt2M
      },
      handleSuccess(response) {
        this.player.profile = response.hash
      },
      handleCertificateFront(response) {
        this.player.certificateFrontImg = response.hash
      },
      handleCertificateBack(response) {
        this.player.certificateBackImg = response.hash
      },
      handleError() {

      },
      getQiniuToken() {
        getQiniuUploadToken().then(response => {
          const data = response.data
          this.dataObj.token = data.token
        }).catch(err => {
          console.log(err, 'error', '七牛Token获取失败')
        })
      },
      setUserManage() {
        this.userLoding = true
        //////
        if (this.player.refereeCertificateDate) {
          this.player.refereeCertificateDate = getDateObjectByString(this.player.refereeCertificateDate)
          this.player.refereeCertificateDate = moment(this.player.refereeCertificateDate).format('YYYY-MM-DDTHH:mm:ss+0800')
        }
        if (this.player.birthday) {
          this.player.birthday = getDateObjectByString(this.player.birthday)
          this.player.birthday = moment(this.player.birthday).format('YYYY-MM-DDTHH:mm:ss+0800')
        }
        let params = {
          id: this.playerId,
          profile: this.player.profile,
          trueName: this.player.trueName,
          gender: this.player.gender,
          nationality: this.player.nationality,
          birthday: this.player.birthday,
          certificateType: this.player.certificateType, ///
          certificateNum: this.player.certificateNum,
          certificateFrontImg: this.player.certificateFrontImg,
          certificateBackImg: this.player.certificateBackImg,
          inField: this.player.inField, ////
          email: this.player.email,
          high: this.player.high,
          weight: this.player.weight,
          educationLevel: this.player.educationLevel,
          foreignLanguage: this.player.foreignLanguage,
          instructorLevel: this.player.instructorLevel,
          refereeLevel: this.player.refereeLevel,
          refereeCertificateNo: this.player.refereeCertificateNo,
          refereeCertificateDate: this.player.refereeCertificateDate,
          employerOrganization: this.player.employerOrganization,
          workplaceAddress: this.player.workplaceAddress,
          athletePerformance: this.player.athletePerformance,
          refereePerformance: this.player.refereePerformance,
          trainingPerformance: this.player.trainingPerformance,
          contactnumber: this.player.contactnumber,
          mobile: this.player.mobile,
          address: this.player.address,
          trainings: this.trainingList
        }
        if(this.language.level) {
          params.foreignLanguage = this.language.foreign + '|' + this.language.level
        }
        if (this.player.source === this.sourceList[3]) {
          params.source = this.player.otherSource
        } else {
          params.source = this.player.source
        }
        /////
        updateReferee(params).then((resolve) => {
          const data = resolve.data
          if(data) {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
          }else{
            this.$message.error('数据保存失败')
          }
          this.userLoding = false
        }, (reject) => {
          this.userLoding = false
          this.$message.error('数据保存失败')
        })
      },
      getHistoryMembershipYear(userId) {
        getHistoryMembershipYear(userId, 4).then(response => {
          const data = response.data
          this.historyYears = data.list
        }).catch(err => {
        })
      },
      getOrganization() {
        getOrganizationList().then((resolve) => {
          this.organizationId = resolve.data.list
        }, (reject) => {})
      },
      getCoach() {
        getCoachList().then((resolve) => {
          this.coach = resolve.data.list
        }, (reject) => {})
      }
    },
    filters: {
      ImageFormats(img) {
        return ImageFormat.fileView(img)
      },
      ImageCertFormats(img) {
        return ImageFormat.imageView(img, 960, 594, 2)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .referee-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .label-line-height .el-form-item__label {
      line-height: 80px;
      text-align: center;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: 80%;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .el-date-editor .el-range-separator {
      width: auto;
    }

    .el-input--small {
      max-width: 300px;
    }

    .el-dropdown {
      cursor: pointer;
    }
  }
  .el-popover .popover-content img {
    max-width: 360px;
  }
</style>
